import React, { useState, useEffect, useContext, useRef } from 'react'
import {
  Layout,
  Card,
  Table,
  Button,
  Input,
  Divider,
  Row,
  Col,
  message,
  Form,
  Select,
  Tooltip,
  Spin,
  DatePicker,
  AutoComplete,
  Alert,
  Space,
  Modal,
  InputNumber
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import {
  ArrowLeftOutlined,
  ShoppingCartOutlined,
  WarningOutlined
} from '@ant-design/icons'
import { InputGroup, ModalFooter } from 'reactstrap'
import TextArea from 'antd/lib/input/TextArea'
import { useDispatch, useSelector } from 'react-redux'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { PRODUCT_SCREEN, STOCK_LIST } from '../../../constants/Pages'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import {
  notAllowMsgCheck,
  isEmptyObject,
  checkRightspermissions,
  getDecryptID,
  formatDigits,
  loadProductBatchesRowData,
  loadSearchSelectedProduct,
  loadGeneralImportProducts,
  getEncryptedID,
  verifyPkgFeature
} from '../../../appRedux/actions'
import moment from 'moment'
import { PurchaseOrderType } from '../../../constants/PurchaseOrderType'
import { text } from '@fortawesome/fontawesome-svg-core'
import { StockOrderTypesEnum } from '../../../constants/StockOrderTypesEnum'
import ProductBatches from '../../../components/ProductBatches'
import ProductSearch from '../../../components/ProductSearch'
import { StringIsNullOrEmpty } from '../../../appRedux/actions'
import GeneralProductImport from '../../../components/GeneralProductImport'
import ProductLink from '../../../components/ProductScreen/ProductLink'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'
const bgcolor = '#e5eaed'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const AddStock = ({ match }) => {
  const mode =
    match.params.mode != undefined
      ? match.params.mode.toString().toLowerCase()
      : ''
  const history = useHistory()
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  //#region useSelector
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getSearchSelectedProduct = useSelector(
    ({ Products }) => Products.searchSelectedProduct
  )
  const getReduxProductBatchesRowData = useSelector(
    ({ Products }) => Products.getProductBatchesRowData
  )
  const getReduxGeneralImportProducts = useSelector(
    ({ Products }) => Products.generalImportProducts
  )
  //#endregion useSelector

  //#region useState

  const [isLoading, SetisLoading] = React.useState(false) //React.useState({ isLoading: isAddMode ? false : true });
  const [isRegistering, SetisRegistering] = React.useState(true)
  const [selectedTestType, setselectedTestType] = useState(1)
  const [selected, setselected] = useState([])
  const [orderNo, setOrderNo] = useState([])
  const [isPartialCount, setisPartialCount] = useState(true)
  const [grandTotal, setgrandTotal] = useState(0)
  const [supplierData, setSupplierData] = useState([])
  const [outletData, setOutletData] = useState([])
  const [getOutletName, setOutletName] = useState('All Outlets')
  const [getCurrSymbol, setCurrSymbol] = useState('')
  const [getSupplierName, setSupplierName] = useState('')
  const [getIsDifferentSupplier, setIsDifferentSupplier] = useState(false)

  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getIsOrderNumberExist, setIsOrderNumberExist] = useState(false)
  const [isReceivedModalVisible, setIsReceivedModalVisible] = useState(false)
  const [isModalConfirmed, setIsModalConfirmed] = useState(false)
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)

  //#endregion useState

  //#region useEffect
  React.useEffect(() => {
    let mounted = true

    if (mounted) {
      const commonData = getReduxCommonSetting

      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}

      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrSymbol(currencyData.currencySymbol)
      }

      // rights && permissions

      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)

        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)

          setAccessLoading(false)
        } else {
          toInitialState()

          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  React.useEffect(() => {
    let mounted = true
    let newProd = []

    if (mounted) {
      if (
        getReduxGeneralImportProducts &&
        getReduxGeneralImportProducts != null &&
        getReduxGeneralImportProducts.length > 0
      ) {
        newProd = getReduxGeneralImportProducts.map((e, seq) => {
          if (
            form.getFieldValue('SupplierID') &&
            parseInt(getDecryptID(e.supplierID)) !=
              form.getFieldValue('SupplierID')
          ) {
            setIsDifferentSupplier(true)
          }
          return {
            key: e.productID,
            name: e.productName,
            quantity: e.quantity,
            supplyPrice: e.supplyPrice
              ? parseFloat(e.supplyPrice)
              : parseFloat('0.00'),
            inventoryRecord:
              e.inventoryCount && e.inventoryCount.length > 0
                ? e.inventoryCount.map(q => {
                    return {
                      outletName: q.outletName,
                      currentInventory: q.inventory,
                      outletID: q.outletID ? q.outletID.toString() : ''
                    }
                  })
                : [],
            totalInventory: e.totalInventory,
            totalCost: parseFloat(e.quantity * e.supplyPrice).toFixed(2),
            supplierRecord: e.supplierName
              ? [
                  {
                    supplierName: e.supplierName
                  }
                ]
              : [],
            supplierID: parseInt(getDecryptID(e.supplierID)),
            batchLimit: e.batchLimit ? e.batchLimit : 0,
            isProductInventory: e.isProductInventory,
            isVariant: e.isVariant,
            parentProductID: e.parentProductID
              ? getEncryptedID(e.parentProductID)
              : ''
          }
        })

        if (newProd.length > 0) {
          if (
            selected.length > 0 &&
            !selected.some(e => e.key === newProd.key)
          ) {
            setselected(selected.concat(newProd))
          } else if (selected.length == 0) setselected(newProd)
        }
      }
    }
    return () => (mounted = false)
  }, [getReduxGeneralImportProducts])

  useEffect(() => {
    let mounted = true
    if (mounted && selected.length > 0) {
      let total = 0
      selected.forEach(data => {
        total += parseFloat(data.totalCost)
      })
      setgrandTotal(parseFloat(total).toFixed(2))
    }

    return () => (mounted = false)
  }, [selected])

  useEffect(() => {
    let mounted = true
    if (mounted) {
      // if (Object.keys(getReduxCommonSetting).length === 0) {
      //   dispatch(setCommonConfigs(STOCK_LIST));
      // }
      dispatch(setCommonConfigs(STOCK_LIST))
      if (!verifyPkgFeature(PkgFeatures.InventoryManagement)) {
        setIsFeatureAllowed(false)
      }
      getSuppliersService()
      getOutletsService()
    }

    return () => (mounted = false)
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getSearchSelectedProduct) {
        onSelect(getSearchSelectedProduct)
      }
    }
    return () => (mounted = false)
  }, [getSearchSelectedProduct])

  //#endregion useEffect

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }

    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }

    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }

    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }

    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }

    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }
  function toInitialState () {
    setRights([])

    setPermissions([])

    setIsAllowRead(false)

    setIsDisableCreate(true)

    setIsDisableUpdate(true)

    setIsDisableDelete(true)

    setAccessLoading(true)
  }

  //#region Api Services
  async function getSuppliersService () {
    await ds
      .getSuppliers({ IsAll: true }, BEHAVIOUR_TYPE.GET)
      .then(res => {
        SetisRegistering(false)
        if (res.data.data && res.data.data.length > 0) {
          let data = res.data.data.map(e => {
            return {
              id: e.supplierID,
              label: e.supplierName
            }
          })
          setSupplierData(data)
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        SetisRegistering(false)
      })
  }

  async function getOutletsService () {
    const getOutlets = ds.getStoreOutlets()
    await getOutlets
      .then(response => {
        SetisRegistering(false)
        if (response.status == 200) {
          if (response.data.msgCode == 'GENERAL_SUCCESS') {
            if (response.data.data && response.data.data.length > 0) {
              let data = response.data.data
              let outletssData = data.map(e => {
                return {
                  id: e.sOutletId,
                  outlet: e.outletName
                }
              })

              setOutletData(outletssData)
              // if (outletssData && outletssData.length > 0) {
              //   form.setFieldsValue({ DeliverTo: outletssData[0].id });
              // }
            }
          }
        }
      })
      .catch(e => {
        SetisRegistering(false)
        // setIsLoading(false);
        // if (e.response && e.response.status === 401) {
        //   message.error("Token Expired! Redirecting to Login Page");
        //   setTimeout(() => {
        //     dispatch(userLogOut("store.getState()"));
        //   }, 3000);
        // } else {
        //   message.error("Something Went Wrong...");
        // }
      })
  }

  async function postStockOrderService (body, behaviorType, featureID) {
    await ds
      .postStockOrder(body, behaviorType, featureID)
      .then(res => {
        SetisRegistering(false)
        if (res.data.data) {
          //Salis
          dispatch(loadProductBatchesRowData([]))
          if (mode == 'receive') {
            message.success('Successfully Received')
          } else {
            message.success('Successfully Saved')
          }
          history.push('/Dashboard/inventory/stockcontrol/stockcontrollist')
        }
      })
      .catch(error => {
        SetisRegistering(false)
        message.error('Something went wrong...')
      })
  }
  //#endregion Api Services

  //#region Submission Functions
  const onFormFinish = value => {
    if (mode === 'receive' && !isModalConfirmed) {
      setIsReceivedModalVisible(true)
      return // Exit the function to avoid further processing
    }
    const productInventory = []
    selected.forEach(data => {
      productInventory.push({
        ProductID: data.key,
        ProductQuantity: parseInt(data.quantity),
        SupplyPrice: parseFloat(data.supplyPrice)
      })
    })
    if (productInventory && productInventory.length <= 0) {
      return message.error('Kindly add atleast one product')
    }
    SetisRegistering(true)
    const postDataObject = {
      SupplierID:
        value.SupplierID != undefined ? value.SupplierID.toString() : '',
      SupplierInvoiceNumber: value.SupplierInvoiceNbr,
      SourceOutletID: '',
      DestinationOutletID: value.DeliverTo != undefined ? value.DeliverTo : '',
      DeliveryDate: value.DeliveryDate
        ? value.DeliveryDate.format()
        : moment().format(),
      OrderNumber: value.OrderNumber,
      ReturnNumber: '',
      ReferenceName: '',
      Notes: value.Notes,
      StockType:
        mode === 'receive'
          ? parseInt(StockOrderTypesEnum.ReceiveStock)
          : parseInt(StockOrderTypesEnum.OrderStock),
      StockOrderProducts: productInventory,
      ProductBatchesData:
        mode === 'receive' ? getReduxProductBatchesRowData.flat() : []
    }
    postStockOrderService(
      postDataObject,
      BEHAVIOUR_TYPE.POST,
      PkgFeatures.InventoryManagement
    )
    setIsModalConfirmed(false)
  }

  const ReceiveModal = ({
    getIsReceivedModalVisible,
    setIsReceivedModalVisible,
    onConfirmReceive
  }) => {
    return (
      <Modal
        className='Mark-as-Sent-Modal'
        visible={getIsReceivedModalVisible}
        onCancel={() => setIsReceivedModalVisible(false)}
        centered={true}
        width={'800px'}
        title={
          <strong>
            <IntlMessages id='stock.add.youareaboutto' />
          </strong>
        }
        footer={
          <>
            <Button
              className=''
              type='primary'
              onClick={() => setIsReceivedModalVisible(false)}
            >
              <IntlMessages id='stock.add.dontrecieve' />
            </Button>
            <Button className='' type='primary' onClick={onConfirmReceive}>
              <IntlMessages id='stock.add.receivedelivery' />
            </Button>
          </>
        }
      >
        <p>
          <IntlMessages id='stock.add.thisactionispermanent' />
        </p>
      </Modal>
    )
  }

  const handleConfirmReceive = () => {
    setIsModalConfirmed(true)
    setIsReceivedModalVisible(false)
    form.submit()
  }

  const onFinishFailed = errorInfo => {
    message.error('Kindly provide missing fields')
  }

  //#endregion Submission Functions

  //#region Change and Click Functions
  const handleOrderNoChange = event => {
    setOrderNo(event.target.value)
  }
  const validateOrderNumber = (rule, value, callback) => {
    let body = {
      OrderNumber: value,
      PurchaseOrderType: PurchaseOrderType.OrderNumber
    }
    const getIsExist = ds.checkIsOrderNumberExist(body, BEHAVIOUR_TYPE.POST)
    getIsExist
      .then(response => {
        if (response) {
          setIsOrderNumberExist(response)
          callback('This order number already exists. Add a different one.')
        } else {
          callback()
        }
      })
      .catch(e => {})
  }
  const onSelect = async selectedObj => {
    let newProd = []
    let productID = ''
    if (selectedObj && selectedObj != null) {
      if (selectedObj.productID) {
        productID = selectedObj.productID
      }
    } else {
      productID = ''
    }

    if (!StringIsNullOrEmpty(productID)) {
      // Here we call Details API
      await ds
        .getBookSearchProd(
          `?keys=""&outletid=${''}&isstock=${true}&isInventory=${false}&isActiveProduct=${false}&isPB=${false}&isVariantProduct=${true}&productID=${productID}`
        )
        .then(response => {
          const productData = response.data
          if (productData.msgCode == 'GENERAL_SUCCESS') {
            if (productData && productData.data.length > 0) {
              newProd = productData.data.map((e, seq) => {
                if (
                  form.getFieldValue('SupplierID') &&
                  parseInt(getDecryptID(e.supplierID)) !=
                    form.getFieldValue('SupplierID')
                ) {
                  setIsDifferentSupplier(true)
                }
                return {
                  key: e.productID,
                  name: e.productName,
                  quantity: e.quantity,
                  supplyPrice: e.supplyPrice
                    ? parseFloat(e.supplyPrice)
                    : parseFloat('0.00'),
                  inventoryRecord:
                    e.inventoryCount && e.inventoryCount.length > 0
                      ? e.inventoryCount.map(q => {
                          return {
                            outletName: q.outletName,
                            currentInventory: q.inventory,
                            outletID: q.outletID ? q.outletID.toString() : ''
                          }
                        })
                      : [],
                  totalInventory: e.totalInventory,
                  totalCost: parseFloat(e.quantity * e.supplyPrice).toFixed(2),
                  supplierRecord: e.supplierName
                    ? [
                        {
                          supplierName: e.supplierName
                        }
                      ]
                    : [],
                  supplierID: parseInt(getDecryptID(e.supplierID)),
                  batchLimit: e.batchLimit ? e.batchLimit : 0,
                  isProductInventory: e.isProductInventory,
                  isVariant: e.isVariant,
                  parentProductID: e.parentProductID
                    ? getEncryptedID(e.parentProductID)
                    : ''
                }
              })
            }
          }
          if (productData.msgCode == 'GENERAL_ERROR') {
            message.error(productData.msgDescription)
          }
        })
        .catch(e => {
          // console.log("Product Search Issue", e)
        })

      if (newProd.length > 0) {
        if (selected.length > 0 && !selected.some(e => e.key === productID)) {
          setselected(selected.concat(newProd))
        } else if (selected.length == 0) setselected(newProd)
        dispatch(loadSearchSelectedProduct([])) //It is important to Empty Redux
      }
    }
  }
  const cardClickFunction = value => {
    if (value == 1) {
      setisPartialCount(true)
      setselectedTestType(1)
    } else if (value == 2) {
      setisPartialCount(false)
      setselectedTestType(2)
    }
  }
  function removeTableProd (e) {
    let data = selected.filter(a => a.key != e.key)
    setselected(data)

    setIsDifferentSupplier(false)
    let productsData = data
    productsData.forEach(obj => {
      if (obj.supplierID != form.getFieldValue('SupplierID')) {
        setIsDifferentSupplier(true)
      }
    })
    if (data.length == 0) {
      setgrandTotal(0)
    }
  }

  const handleDeliverToChange = e => {
    let name = outletData.filter(a => a.id == e)[0].outlet
    setOutletName(name)
    let body = {
      OutletID: e,
      PurchaseOrderType: PurchaseOrderType.OrderNumber
    }
    const getOrderNumObj = ds.getOrderNumberGenerate(body, BEHAVIOUR_TYPE.POST)
    getOrderNumObj
      .then(response => {
        if (response) {
          if (response != '0') {
            form.setFieldsValue({ OrderNumber: response.toString() })
            setOrderNo(response.toString())
          }
        }
      })
      .catch(e => {})
  }
  const handleClickContinueAnyway = () => {
    setIsDifferentSupplier(false)
  }
  const handleChangeSupplier = (e, i) => {
    setIsDifferentSupplier(false)
    let productsData = selected
    productsData.forEach(obj => {
      if (obj.supplierID != form.getFieldValue('SupplierID')) {
        setIsDifferentSupplier(true)
      }
    })
    setSupplierName(i ? i.children : '')
  }

  //#endregion Change and Click Functions

  //#region  Components

  //#endregion Api Components

  const handleQuantityChange = ({ target: { value } }, index, record) => {
    setselected(prevData => {
      const newData = [...prevData]
      const newItem = { ...newData[index] }
      newItem.quantity = value
      newItem.totalCost = parseFloat(
        parseFloat(record.supplyPrice) * parseInt(value)
      ).toFixed(2)
      newData[index] = newItem
      return newData
    })
  }

  const handleFocus = event => event.target.select()
  function validateInputNumber (rule, value) {
    if (value <= 0) {
      return Promise.reject('Please enter a number greater than zero')
    }
    return Promise.resolve()
  }
  //#region  Columns
  var columns = [
    {
      title: 'Product',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => {
        let pID = record.isVariant ? record.parentProductID : record.key
        return (
          <div>
            <ProductLink ProductId={pID} text={text} />
            {/* <span>{text}ss</span> */}
            {/* form.getFieldValue("SupplierID") && record.supplierID &&
            !(record.supplierID == form.getFieldValue("SupplierID"))  */}
            {form.getFieldValue('SupplierID') != undefined &&
            record.supplierID != form.getFieldValue('SupplierID') &&
            getIsDifferentSupplier ? (
              <p className='error-txt-size'>
                <WarningOutlined className='dk-btn-icon-align' />
                <IntlMessages id='stock.add.fromdifferentsupplier' />
              </p>
            ) : (
              ' '
            )}
          </div>
        )
      }
    },
    {
      title: `Current Inventory(${getOutletName})`,
      dataIndex: 'totalInventory',
      key: 'totalInventory',
      render: (text, record) => {
        let count = text
        let inventoryData = record.inventoryRecord
        if (form.getFieldValue('DeliverTo') != '') {
          let outID = getDecryptID(form.getFieldValue('DeliverTo'))
          if (outID) {
            inventoryData = inventoryData.filter(a => a.outletID == outID)
            if (inventoryData.length > 0) {
              count = inventoryData[0].currentInventory
            } else {
              count = 0
            }
          }
          // else {
          //    if(inventoryData && inventoryData.length > 0){
          //      inventoryData.forEach((obj)=>{
          //       count += parseFloat(obj.currentInventory)
          //      })
          //    }
          // }
        }
        return <span>{record.isProductInventory ? count : '∞'}</span>
      }
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      editable: true,
      render: (text, record, index) => {
        function putQuantity () {
          let keyName = `orderquantity${record.key}`
          form.setFieldsValue({
            [keyName]: record.quantity ? parseFloat(record.quantity) : 0
          })
        }
        putQuantity()
        return (
          <Form
            form={form}
            name='StockForm'
            onFinish={onFormFinish}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >
            <Form.Item
              style={{ margin: 0 }}
              name={`orderquantity${record.key}`}
              rules={[
                {
                  required: true,
                  message: 'Please enter a number'
                },
                {
                  validator: validateInputNumber
                }
              ]}
            >
              <InputNumber
                type='number'
                width={'50'}
                value={text}
                min={1}
                onPressEnter={v => handleQuantityChange(v, index, record)}
                onBlur={v => handleQuantityChange(v, index, record)}
                onFocus={handleFocus}
              />
            </Form.Item>
          </Form>
        )
      },
      shouldCellUpdate: (record, prevRecord) => {
        return record.quantity !== prevRecord.quantity
      }
    },
    {
      title: 'Supply Price',
      dataIndex: 'supplyPrice',
      key: 'supplyPrice',
      editable: true,
      render: (text, record) => {
        let final = text ? parseFloat(text).toFixed(2) : '0.00'
        return (
          <Tooltip
            title={
              <span style={{ color: 'black' }}>
                <IntlMessages id='sell.sell.retrievesell.clicktordfit' />
              </span>
            }
            color={'#d5d6d7'}
          >
            <strong>
              {getCurrSymbol} {formatDigits(final, getDefaultDecimalPlaces)}
            </strong>
          </Tooltip>
        )
      }
    },
    {
      title: 'Total Cost',
      dataIndex: 'totalCost',
      key: 'totalCost',
      render: (text, record) => {
        let totalCost = parseFloat(
          record.quantity * record.supplyPrice
        ).toFixed(2)
        if (selected.length == 1) {
          setgrandTotal(totalCost)
        }
        return (
          <span>
            <strong>
              {getCurrSymbol}{' '}
              {text ? formatDigits(text, getDefaultDecimalPlaces) : '0.00'}
            </strong>
          </span>
        )
      }
    },
    {
      title: '',
      dataIndex: 'remove',
      key: 'remove',
      render: (text, record) => (
        <a
          className='trash-icon-btn'
          onClick={() => removeTableProd(record)}
          style={{ marginLeft: 22, fontSize: 'large' }}
        >
          <i className='icon icon-trash' />
        </a>
      )
    }
  ]

  const columnsInventory = [
    { title: 'Outlet', dataIndex: 'outletName', key: 'outletName' },
    {
      title: 'Current Inventory',
      dataIndex: 'currentInventory',
      key: 'currentInventory'
    }
  ]

  const coloumnSupplier = [
    {
      title: (
        <Row justify='center'>
          <Col>Supplier Name</Col>
        </Row>
      ),
      dataIndex: 'supplierName',
      key: 'supplierName',
      render: (text, record) => {
        return <strong>{text}</strong>
      }
    }
  ]

  //#endregion  Columns

  return (
    <>
      {!getIsDisableCreate && isFeatureAllowed ? (
        <div className='Content-wrapper AddPurchaseOrder-pg'>
          {isLoading.isLoading ? (
            <Skeleton count={12} height={30} />
          ) : (
            <>
              <Spin
                tip={<IntlMessages id='sell.cashlisting.cashloading' />}
                spinning={isRegistering}
                size='large'
              >
                <ReceiveModal
                  getIsReceivedModalVisible={isReceivedModalVisible}
                  setIsReceivedModalVisible={setIsReceivedModalVisible}
                  onConfirmReceive={handleConfirmReceive}
                />

                <div className='back-arrow-h1'>
                  <h1 className='d-flex align-items-center'>
                    <ArrowLeftOutlined
                      className='dk-vertical-align'
                      onClick={() =>
                        history.push(
                          '/Dashboard/inventory/stockcontrol/stockcontrollist'
                        )
                      }
                    />
                    <span className='mx-2'>
                      {' '}
                      {mode === 'receive' ? (
                        <IntlMessages id='stock.add.receive' />
                      ) : (
                        <IntlMessages id='stock.add.addpurchase' />
                      )}
                    </span>
                  </h1>
                </div>

                <Row className='ant-row dk-row-bg-color m-0 Sec-heading-bg'>
                  <Col lg={18} md={12} sm={14} xs={24}>
                    <p className='title vd-hero-intro custom-font-color-black m-0'>
                      {mode === 'receive' ? (
                        <IntlMessages id='stock.add.receive' />
                      ) : (
                        <IntlMessages id='stock.add.addpurchase' />
                      )}
                    </p>
                  </Col>
                  <Col lg={6} md={12} sm={10} xs={24}>
                    <div className='pg-header-btn'>
                      <Button
                        className='dk-btn-cancel dk-wd-auto'
                        type='primary'
                        onClick={() =>
                          history.push(
                            '/Dashboard/inventory/stockcontrol/stockcontrollist'
                          )
                        }
                        size='large'
                      >
                        <IntlMessages id='products.main.add.cancel' />
                      </Button>
                      <Button
                        className='dk-btn-add dk-wd-auto'
                        disabled={isRegistering}
                        form='StockForm'
                        htmlType='submit'
                        type='primary'
                        size='large'
                      >
                        {mode === 'receive' ? (
                          <IntlMessages id='stock.add.receivebtn' />
                        ) : (
                          <IntlMessages id='stock.add.savebtn' />
                        )}
                      </Button>
                    </div>
                  </Col>
                </Row>

                <div className='custom-mg-top-25'>
                  <Row className='Details-div'>
                    <Col lg={6} md={24} sm={24} xs={24}>
                      <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                        {mode === 'receive' ? (
                          <IntlMessages id='stock.add.delivdetail' />
                        ) : (
                          <IntlMessages id='stock.add.detail' />
                        )}
                      </h2>
                      <p className='dk-font-size-15'>
                        <IntlMessages id='stock.add.detailp' />
                      </p>
                    </Col>

                    <Col
                      lg={18}
                      md={24}
                      sm={24}
                      xs={24}
                      className='p-0-add-form'
                    >
                      <Form
                        {...formItemLayout}
                        form={form}
                        name='StockForm'
                        onFinish={onFormFinish}
                        onFinishFailed={onFinishFailed}
                        scrollToFirstError
                      >
                        <InputGroup size='large' className='md-col-100'>
                          <Form.Item
                            className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                            name='SupplierID'
                            label={<IntlMessages id='stock.add.supp' />}
                            rules={[
                              {
                                required: true,
                                message: (
                                  <IntlMessages id='products.promoadd.disperalert' />
                                )
                              }
                            ]}
                          >
                            <Select
                              size='large'
                              width='100%'
                              showSearch
                              optionFilterProp='children'
                              onChange={handleChangeSupplier}
                              placeholder={'Choose a supplier'}
                            >
                              {supplierData &&
                                supplierData.length > 0 &&
                                supplierData.map((data, i) => {
                                  return (
                                    <Select.Option key={i} value={data.id}>
                                      {data.label}
                                    </Select.Option>
                                  )
                                })}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                            name='DeliverTo'
                            label={<IntlMessages id='stock.add.delto' />}
                            rules={[
                              {
                                required: true,
                                message: (
                                  <IntlMessages id='products.promoadd.disperalert' />
                                )
                              }
                            ]}
                          >
                            <Select
                              onChange={e => {
                                handleDeliverToChange(e)
                              }}
                              size='large'
                              showSearch
                              optionFilterProp='children'
                              placeholder={'Choose an outlet'}
                            >
                              {outletData &&
                                outletData.length > 0 &&
                                outletData.map((data, i) => {
                                  return (
                                    <Select.Option key={i} value={data.id}>
                                      {data.outlet}
                                    </Select.Option>
                                  )
                                })}
                            </Select>
                          </Form.Item>
                        </InputGroup>

                        <InputGroup size='large' className='md-col-100'>
                          <Form.Item
                            className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                            name='SupplierInvoiceNbr'
                            label={<IntlMessages id='stock.add.suppinv' />}
                          >
                            <Input
                              placeholder='Enter a supplier invoice number'
                              size='large'
                            />
                          </Form.Item>
                          <Form.Item
                            className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                            name='DeliveryDate'
                            label={<IntlMessages id='stock.add.deldate' />}
                          >
                            <DatePicker
                              className='w-100'
                              size='large'
                              inputReadOnly={true}
                            />
                          </Form.Item>
                        </InputGroup>

                        <Row>
                          <Col
                            xl={12}
                            lg={24}
                            md={24}
                            sm={24}
                            xs={24}
                            className='md-pad-0'
                          >
                            <Form.Item
                              className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment form-inner-pad-0'
                              name='OrderNumber'
                              label={<IntlMessages id='stock.add.ordernbr' />}
                              rules={[
                                {
                                  required: true,
                                  message: (
                                    <IntlMessages id='products.promoadd.disperalert' />
                                  )
                                },
                                {
                                  validator: validateOrderNumber
                                }
                              ]}
                            >
                              <Input
                                placeholder='Order number'
                                size='large'
                                onBlur={handleOrderNoChange}
                              />
                            </Form.Item>
                          </Col>
                          <Col
                            xl={12}
                            lg={24}
                            md={24}
                            sm={24}
                            xs={24}
                            className='md-pad-0'
                          >
                            {mode == 'receive' ? (
                              ''
                            ) : (
                              <div className='dk-preview-padding'>
                                <label>
                                  <IntlMessages id='products.promoadd.preview' />
                                </label>
                                <div className='dk-stock-card-prev'>
                                  <Card>
                                    <div className='Preview-box'>
                                      <span className='OrderNumber-icon'>
                                        <ShoppingCartOutlined />
                                      </span>
                                      <span className='OrderNumber-title'>
                                        <p className='mb-0'>
                                          {!StringIsNullOrEmpty(orderNo) ? (
                                            orderNo
                                          ) : (
                                            <IntlMessages id='stock.add.ordernumber' />
                                          )}
                                        </p>
                                        <p className='mb-0'>
                                          <IntlMessages id='stock.add.trackwhentheorder' />
                                        </p>
                                      </span>
                                    </div>
                                    <Divider className='mt-3 mb-3' />
                                    <p className='mb-0'>
                                      <IntlMessages id='products.promoadd.carddesc' />
                                    </p>
                                  </Card>
                                </div>
                              </div>
                            )}
                          </Col>
                        </Row>

                        <InputGroup size='large' className='md-col-100 w-100'>
                          <Form.Item
                            className='ant-form-item-label-custom w-100 md-inner-pad-0'
                            name='Notes'
                            label={<IntlMessages id='stock.add.note' />}
                          >
                            <TextArea
                              rows={4}
                              placeholder={'Enter a note for this delivery'}
                              size='large'
                            />
                          </Form.Item>
                        </InputGroup>
                      </Form>
                    </Col>
                  </Row>

                  <Divider className='mt-3 mb-4' />

                  <Row className='Products-div'>
                    <Col lg={6} md={24} sm={24} xs={24}>
                      <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                        <IntlMessages id='products.addpricebook.products' />
                      </h2>
                      <p className='dk-font-size-15'>
                        <IntlMessages id='stock.add.proddetail' />
                      </p>
                    </Col>

                    <Col lg={18} md={24} sm={24} xs={24}>
                      {mode == 'receive' ? (
                        ' '
                      ) : (
                        <Row className='dk-flex-promo'>
                          <Col
                            lg={12}
                            md={12}
                            sm={12}
                            xs={24}
                            className='dk-flex-promo-1'
                          >
                            <div className='dk-custom-promoadd-card1 dk-flex-promo-1'>
                              <Card
                                className={`${
                                  selectedTestType == 1
                                    ? 'ant-card-bordered-active'
                                    : ''
                                }`}
                                // onClick={() => cardClickFunction(1)}
                                onClick={() => cardClickFunction(1)}
                              >
                                <h3>
                                  <IntlMessages id='stock.add.choseprod' />
                                </h3>
                                <Divider />
                                <p className='mb-0'>
                                  <IntlMessages id='stock.add.searchcan' />
                                </p>
                              </Card>
                            </div>
                          </Col>
                          <Col
                            lg={12}
                            md={12}
                            sm={12}
                            xs={24}
                            className='dk-flex-promo-1'
                          >
                            <div className='dk-custom-promoadd-card1 dk-flex-promo-1'>
                              <Card
                                className={`${
                                  selectedTestType == 2
                                    ? 'ant-card-bordered-active'
                                    : ''
                                }`}
                                onClick={() => cardClickFunction(2)}
                                // onClick={() => cardClickFunction(2)}
                              >
                                <h3>
                                  <IntlMessages id='stock.add.impostcsv' />
                                </h3>
                                <Divider />
                                <p className='mb-0'>
                                  <IntlMessages id='stock.add.impostcsvdet' />
                                </p>
                              </Card>
                            </div>
                          </Col>
                        </Row>
                      )}

                      <Divider className='mb-4' />

                      <>
                        {getIsDifferentSupplier ? (
                          <Alert
                            //  message="Warning"
                            description={`This order contains products from a different supplier than “${getSupplierName}”.`}
                            type='error'
                            //  showIcon
                            action={
                              <Space direction='vertical'>
                                <Button
                                  size='small'
                                  type='primary'
                                  className='dk-btn-cancel'
                                  onClick={handleClickContinueAnyway}
                                >
                                  <IntlMessages id='stock.add.continueanyway' />
                                </Button>
                              </Space>
                            }
                            icon={
                              <WarningOutlined className='dk-btn-icon-align' />
                            }
                          />
                        ) : (
                          ''
                        )}

                        <Row>
                          <Col md={24} xs={24} sm={24}>
                            {selected && selected.length > 0 ? (
                              <Table
                                className='gx-table-responsive MinWidth-auto'
                                columns={columns}
                                expandable={{
                                  expandedRowRender: (record, index) => (
                                    <>
                                      <Row>
                                        <Col md={12}>
                                          <div className='div-cursor-pointer'>
                                            <Card
                                              title={
                                                <h2>
                                                  <IntlMessages id='product.stock.inventory' />
                                                </h2>
                                              }
                                              style={{
                                                textAlign: 'Center',
                                                borderRadius: 'inherit',
                                                display: 'grid'
                                              }}
                                            >
                                              {record.inventoryRecord &&
                                                record.inventoryRecord.length >
                                                  0 && (
                                                  <Table
                                                    className='gx-table-responsive'
                                                    columns={columnsInventory}
                                                    footer={false}
                                                    dataSource={
                                                      record.inventoryRecord
                                                    }
                                                    pagination={false}
                                                  ></Table>
                                                )}
                                            </Card>
                                          </div>
                                        </Col>
                                        <Col md={12}>
                                          <div className='div-cursor-pointer'>
                                            {record &&
                                              record.supplierRecord &&
                                              record.supplierRecord.length >
                                                0 && (
                                                <Card
                                                  title={
                                                    <h2>
                                                      <IntlMessages id='product.stock.supplier' />
                                                    </h2>
                                                  }
                                                  style={{
                                                    textAlign: 'Center',
                                                    borderRadius: 'inherit',
                                                    display: 'grid'
                                                  }}
                                                >
                                                  <Table
                                                    className='gx-table-responsive'
                                                    columns={coloumnSupplier}
                                                    dataSource={
                                                      record.supplierRecord
                                                    }
                                                    pagination={false}
                                                    footer={false}
                                                  ></Table>
                                                </Card>
                                              )}
                                          </div>
                                        </Col>
                                      </Row>
                                      {mode === 'receive' ? (
                                        <ProductBatches
                                          record={record}
                                          index={index}
                                          form={form}
                                          name={'StockForm'}
                                          onFinish={onFormFinish}
                                        />
                                      ) : (
                                        ''
                                      )}
                                    </>
                                  ),

                                  rowExpandable: record =>
                                    record.name !== 'Not Expandable'
                                }}
                                pagination={false}
                                footer={false}
                                dataSource={selected}
                                rowClassName={() => 'editable-row'}
                              />
                            ) : (
                              <Row style={{ marginBottom: 18 }}>
                                <Col md={4}>
                                  <strong>
                                    <IntlMessages id='products.addpricebook.products' />
                                  </strong>
                                </Col>
                                <Col md={8}>
                                  <strong>
                                    <IntlMessages id='stock.add.currinv' />
                                  </strong>
                                </Col>
                                <Col md={4}>
                                  <strong>
                                    <IntlMessages id='stock.add.quan' />
                                  </strong>
                                </Col>
                                <Col md={4}>
                                  <strong>
                                    <IntlMessages id='stock.add.suppprice' />
                                  </strong>
                                </Col>
                                <Col md={4}>
                                  <strong>
                                    <IntlMessages id='stock.add.total' />
                                  </strong>
                                </Col>
                              </Row>
                            )}
                          </Col>
                        </Row>
                        <Row className='pro-search-bar mt-2'>
                          <Col lg={24} md={24} sm={24} xs={24}>
                            {isPartialCount ? (
                              <ProductSearch isLabel={false} />
                            ) : (
                              <GeneralProductImport isDraggerActive={true} />
                            )}
                          </Col>
                        </Row>

                        <Row className='total-div mt-3' justify={'end'}>
                          <Col
                            lg={24}
                            md={24}
                            sm={24}
                            xs={24}
                            className='text-right'
                          >
                            <h2>
                              <IntlMessages id='stock.add.total' />:{' '}
                              {grandTotal ? (
                                <>
                                  {getCurrSymbol}{' '}
                                  {formatDigits(
                                    grandTotal,
                                    getDefaultDecimalPlaces
                                  )}
                                </>
                              ) : (
                                '0.00'
                              )}
                            </h2>
                          </Col>
                        </Row>
                      </>
                    </Col>
                  </Row>
                </div>
              </Spin>
            </>
          )}
        </div>
      ) : (
        <NotAllowedComponent
          getAccessLoading={getAccessLoading}
          textType={!isFeatureAllowed ? 2 : 1}
        />
      )}
    </>
  )
}

export default AddStock
